const zhTw = {
  'feedback.title': '問題回報',
  'feedback.bug.title': '報告錯誤',
  'feedback.bug.desc': '讓我們知道哪裡出了問題',
  'feedback.improvment.title': '建議改進',
  'feedback.improvment.desc': '我們可以如何改進',
  'feedback.record': '錄製故障',
  'feedback.module': '請輸入故障所屬的功能',
  'feedback.desc': '請詳細描述故障發生時的操作細節',
  'feedback.tips': '👇 操作完成後請點此按鈕結束',
  'feedback.checkbox': '我已閱讀並同意數據收集條款',
  'feedback.start': '開始錄製',
  'feedback.agree': '我同意',
  'feedback.cancel': '取消',
  'feedback.submit': '提交',
  'feedback.close': '關閉',
  'feedback.form.title': '請輸入標題',
  'feedback.form.desc': '請詳細說明操作細節',
  'feedback.stop': '結束錄製',
  'feedback.form.email': '請輸入你的電子信箱',
  'feedback.success': '感謝您的反饋，OneShip 會盡快查看您的問題',
  'feedback.iknow': '我知道了',
  'feedback.record.tips': '點選下方按鈕，可對您的操作路徑進行錄製',
  'feedback.desc.error.tips': '詳細說明故障操作細節（必填）',
  'feedback.desc.advise.tips': '詳細說明改進操作細節（必填）',
  'feedback.agree.tips': '請閱讀並同意隱私協議',
  'common.formValidRequired': '必填',
  'common.input.placeholder': '請輸入',
  'common.formValidEmail': '請輸入正確的電郵',
  'common.formValidLengthLessThan': '長度不能超過{{length}}個字元',
} as const

export type IKEYS = keyof typeof zhTw

const zhHk = {
  'feedback.title': '問題回報',
  'feedback.bug.title': '報告錯誤',
  'feedback.bug.desc': '讓我們知道哪裡出了問題',
  'feedback.improvment.title': '建議改進',
  'feedback.improvment.desc': '我們可以如何改進',
  'feedback.record': '錄製故障',
  'feedback.module': '請輸入故障所屬的功能',
  'feedback.desc': '請詳細描述故障發生時的操作細節',
  'feedback.tips': '👇 操作完成後請點此按鈕結束',
  'feedback.checkbox': '我已閱讀並同意數據收集條款',
  'feedback.start': '開始錄製',
  'feedback.agree': '我同意',
  'feedback.cancel': '取消',
  'feedback.submit': '提交',
  'feedback.close': '關閉',
  'feedback.form.title': '請輸入標題',
  'feedback.form.desc': '請詳細說明操作細節',
  'feedback.stop': '結束錄製',
  'feedback.form.email': '請輸入你的電子信箱',
  'feedback.success': '感謝您的反饋，OneShip 會盡快查看您的問題',
  'feedback.iknow': '我知道了',
  'feedback.record.tips': '點選下方按鈕，可對您的操作路徑進行錄製',
  'feedback.desc.error.tips': '詳細說明故障操作細節（必填）',
  'feedback.desc.advise.tips': '詳細說明改進操作細節（必填）',
  'feedback.agree.tips': '請閱讀並同意隱私協議',
  'common.formValidRequired': '必填',
  'common.input.placeholder': '請輸入',
  'common.formValidEmail': '請輸入正確的電郵',
  'common.formValidLengthLessThan': '長度不能超過{{length}}個字元',
} as const

const zh = {
  'feedback.title': '问题反馈',
  'feedback.bug.title': '报告错误',
  'feedback.bug.desc': '让我们知道哪里出了问题',
  'feedback.improvment.title': '改进建议',
  'feedback.improvment.desc': '我们如何可以改进',
  'feedback.record': '录制故障',
  'feedback.module': '请输入故障所属模块',
  'feedback.desc': '请详细说明故障操作细节',
  'feedback.tips': '👇 操作完成后可点击此按钮结束',
  'feedback.checkbox': '我阅读并同意数据收集提示',
  'feedback.start': '开始录制',
  'feedback.agree': '我同意',
  'feedback.cancel': '取消',
  'feedback.submit': '提交',
  'feedback.close': '关闭',
  'feedback.form.title': '请输入标题',
  'feedback.form.desc': '请详细说明操作细节',
  'feedback.stop': '结束录制',
  'feedback.form.email': '请输入你的邮箱',
  'feedback.success': '感谢您的反馈，OneShip团队会尽快查看您的问题',
  'feedback.record.tips': '点击下方按钮，可对您的操作路径进行录制',
  'feedback.desc.error.tips': '请详细说明故障操作细节（必填）',
  'feedback.desc.advise.tips': '请详细说明改进操作细节（必填）',
  'feedback.iknow': '我知道了',
  'feedback.agree.tips': '请阅读并同意隐私协议',
  'common.formValidRequired': '必填',
  'common.formValidEmail': '请输入正确的邮箱地址',
  'common.formValidLengthLessThan': '長度不能超過{{length}}個字符',
}

const vi = {
  'feedback.title': 'Phản hồi',
  'feedback.bug.title': 'Báo cáo lỗi',
  'feedback.bug.desc': 'Vui lòng cho chúng tôi biết vấn đề bạn gặp phải',
  'feedback.improvment.title': 'Đề xuất cải thiện',
  'feedback.improvment.desc': 'Vui lòng cho chúng tôi biết cách chúng tôi có thể cải thiện dịch vụ của mình',
  'feedback.record': 'Ghi lại lỗi',
  'feedback.module': 'Vui lòng nhập vị trí xảy ra lỗi',
  'feedback.desc': 'Vui lòng mô tả chi tiết hoạt động khi xảy ra lỗi',
  'feedback.tips': '👇 Nhấp vào đây sau khi hoàn tất thao tác.',
  'feedback.checkbox': 'Tôi đã đọc và đồng ý với các điều khoản thu thập dữ liệu',
  'feedback.start': 'Bắt đầu quay',
  'feedback.agree': 'Tôi đồng ý',
  'feedback.cancel': 'Hủy',
  'feedback.submit': 'Gửi',
  'feedback.close': 'Đóng',
  'feedback.form.title': 'Vui lòng điền tiêu đề',
  'feedback.form.desc': 'Vui lòng giải thích chi tiết thao tác',
  'feedback.stop': 'kết thúc ghi âm',
  'feedback.form.email': 'Vui lòng nhập địa chỉ email của bạn ',
  'feedback.success': 'Cảm ơn bạn đã phản hồi, OneShip sẽ kiểm tra và liên hệ lại với bạn trong thời gian sớm nhất.',
  'feedback.iknow': 'Đã rõ.',
  'feedback.record.tips': 'Vui lòng nhấp vào nút bên dưới để quay lại màn hình thao tác',
  'feedback.desc.error.tips': 'Vui lòng mô tả chi tiết lỗi (bắt buộc)',
  'feedback.desc.advise.tips': 'Vui lòng mô tả chi tiết cách cải tiến (bắt buộc)',
  'feedback.agree.tips': 'Vui lòng đọc và đồng ý với thỏa thuận bảo mật.',
  'common.formValidRequired': 'Bắt buộc',
  'common.input.placeholder': 'Vui lòng nhập',
  'common.formValidEmail': 'Địa chỉ email không hợp lệ',
  'common.formValidLengthLessThan': 'Không được vượt quá {{length}}ký tự',
}

const th = {
  'feedback.title': 'ข้อเสนอแนะ',
  'feedback.bug.title': 'รายงานข้อผิดพลาด',
  'feedback.bug.desc': 'โปรดบอกเราเกี่ยวกับปัญหาของคุณ',
  'feedback.improvment.title': 'คำแนะนำเพื่อการปรับปรุง',
  'feedback.improvment.desc': 'โปรดแจ้งให้เราทราบว่าเราจะปรับปรุงการบริการของเราได้อย่างไร',
  'feedback.record': 'บันทึกข้อผิดพลาด',
  'feedback.module': 'โปรดระบุสถานที่ที่เกิดความล้มเหลว',
  'feedback.desc': 'โปรดอธิบายรายละเอียดการดำเนินการเมื่อเกิดความล้มเหลวขึ้น',
  'feedback.tips': '👇 คลิกที่นี่เมื่อการปฏิบัติงานเสร็จสิ้น',
  'feedback.checkbox': 'ฉันได้อ่านและยอมรับเงื่อนไขการเก็บรวบรวมข้อมูล',
  'feedback.start': 'เริ่มการบันทึก',
  'feedback.agree': 'ฉันยอมรับการใช้งาน',
  'feedback.cancel': 'ยกเลิก',
  'feedback.submit': 'ส่ง',
  'feedback.close': 'ปิด',
  'feedback.form.title': 'โปรดระบุหัวข้อ',
  'feedback.form.desc': 'โปรดอธิบายรายละเอียดการดำเนินการ',
  'feedback.stop': 'จบการบันทึก',
  'feedback.form.email': 'ดำเนินการสำเร็จ',
  'feedback.success': 'ขอบคุณสำหรับคำติชม ทีมงาน OneShip จะตรวจสอบและติดต่อกลับหาคุณโดยเร็วที่สุด',
  'feedback.iknow': 'ฉันเข้าใจแล้ว',
  'feedback.record.tips': 'โปรดคลิกที่ปุ่มด้านล่างเพื่อบันทึกหน้าจอแผนการปฏิบัติงาน',
  'feedback.desc.error.tips': 'โปรดอธิบายรายละเอียดข้อผิดพลาดในการปฏิบัติงาน (จำเป็น)',
  'feedback.desc.advise.tips': 'โปรดอธิบายการแก้ไขข้อผิดพลาดในการปฏิบัติงาน (จำเป็น)',
  'feedback.agree.tips': 'โปรดอ่านและยอมรับข้อตกลงความเป็นส่วนตัว',
  'common.formValidRequired': 'จำเป็น',
  'common.input.placeholder': 'กรุณากรอก',
  'common.formValidEmail': 'กรอกโค้ดเชิญ',
  'common.formValidLengthLessThan': 'ไม่สามารถเกิน {{length}} ตัวอักษร',
}

const id = {
  'feedback.title': 'Kritik dan Saran',
  'feedback.bug.title': 'Kesalahan laporan',
  'feedback.bug.desc': 'Tolong beri tahu kami tentang masalah Anda',
  'feedback.improvment.title': 'Saran untuk perbaikan',
  'feedback.improvment.desc': 'Tolong beri tahu kami bagaimana kami dapat meningkatkan kualitas layanan kami',
  'feedback.record': 'Kesalahan rekaman',
  'feedback.module': 'Silakan masukkan letak kegagalan',
  'feedback.desc': 'Silakan jelaskan secara rinci ketika operasi gagal',
  'feedback.tips': '👇 Klik di sini setelah operasi selesai.',
  'feedback.checkbox': 'Saya telah membaca dan menyetujui ketentuan pengumpulan data',
  'feedback.start': 'Mulai merekam',
  'feedback.agree': 'Saya setuju',
  'feedback.cancel': 'Batal',
  'feedback.submit': 'Kirim',
  'feedback.close': 'Tutup',
  'feedback.form.title': 'Silakan masukkan judul',
  'feedback.form.desc': 'Silakan jelaskan rincian dari operasinya',
  'feedback.stop': 'Akhiri rekaman',
  'feedback.form.email': 'Silakan masukkan alamat email Anda',
  'feedback.success': 'Terima kasih atas tanggapan Anda, tim OneShip akan segera memeriksa dan menghubungi Anda kembali.',
  'feedback.iknow': 'Mengerti',
  'feedback.record.tips': 'Silakan klik tombol di bawah ini untuk merekam layar jalur operasi',
  'feedback.desc.error.tips': 'Harap jelaskan rincian kesalahan operasional (wajib)',
  'feedback.desc.advise.tips': 'Harap jelaskan rincian kesalahan yang mengalami peningkatan (wajib)',
  'feedback.agree.tips': 'Harap membaca dan menyetujui perjanjian privasi.',
  'common.formValidRequired': 'Diperlukan',
  'common.input.placeholder': 'Silakan masuk',
  'common.formValidEmail': 'Alamat email tidak berlaku',
  'common.formValidLengthLessThan': 'Kurang dari {{length}} karakter',
}

const en = {
  'feedback.title': 'Feedback',
  'feedback.bug.title': 'Error report',
  'feedback.bug.desc': 'Please tell us about your problem',
  'feedback.improvment.title': 'Suggest improvements',
  'feedback.improvment.desc': 'Please kindly let us know how can we improve our services',
  'feedback.record': 'Record errors',
  'feedback.module': 'Please enter the location of the failure',
  'feedback.desc': 'Please describe the operation details when the failure occurred',
  'feedback.tips': '👇 Click here once the operation is completed.',
  'feedback.checkbox': 'I have read and agree to the data collection terms',
  'feedback.start': 'Start recording',
  'feedback.agree': 'I agree',
  'feedback.cancel': 'Cancel',
  'feedback.submit': 'Submit',
  'feedback.close': 'Close',
  'feedback.form.title': 'Please enter a title',
  'feedback.form.desc': 'Please explain the details of the operation',
  'feedback.stop': 'End recording',
  'feedback.form.email': 'Please enter your email address',
  'feedback.success': 'Thank you for your feedback, OneShip team will check and get back to you soon.',
  'feedback.iknow': 'Understood',
  'feedback.record.tips': 'Please click the button below to record screen of operation path',
  'feedback.desc.error.tips': 'Please describe operational error details (required)',
  'feedback.desc.advise.tips': 'Please describe improved error details (required)',
  'feedback.agree.tips': 'Please read and agree the privacy agreement.',
  'common.formValidRequired': 'Required',
  'common.input.placeholder': 'Please enter',
  'common.formValidEmail': 'Invalid email address',
  'common.formValidLengthLessThan': 'Less than {{length}} characters',
}

const in18Map = {
  'zh-CN': zh,
  'zh-TW': zhTw,
  'zh-HK': zhHk,
  en: en,
  th: th,
  vi: vi,
  id: id,
  t: function (key?: string, data?: Record<string, any>) {
    const lang = window.localStorage.getItem('i18nextLng')
    const map = this[lang] || {}

    const word = map[key] || ''

    if (!data) {
      return word
    }

    return Object.entries(data).reduce((str, [key, value]) => {
      return str.replace(`{{${key}}}`, value)
    }, word)
  },
}

export default in18Map
